type AuthMethod = 'email' | 'google'

const STORAGE_KEY = 'lastAuthMethod'

export function getLastUsedMethod() {
  return localStorage.getItem(STORAGE_KEY) as AuthMethod | null
}

export function rememberLastUsedMethod(method: AuthMethod) {
  localStorage.setItem(STORAGE_KEY, method)
}
